import { Box, styled } from "@mui/material";

export const TopNavigationContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$height",
})<{ $height?: number }>(({ theme, $height }) => ({
  position: "fixed",
  top: "var(--bannerHeight, 0px)",
  left: 0,
  right: 0,
  width: "100%",
  height: $height,
  zIndex: 400,
  backgroundColor: theme.palette.background.paper,
  insetInlineStart: 0, // Ensures it starts at left edge, not offset by LeftPanel
}));
